
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M100.5.4c55.2 0 100 44.8 100 100s-44.8 100-100 100-100-44.8-100-100S45.3.4 100.5.4z"}}),_c('path',{attrs:{"fill":"#757474","d":"M71 41.8v117.3l82.6-58.7z"}})])
          )
        }
      }
    